module.exports = __webpack_public_path__ + "static/media/books.d8978565.svg";